import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filtroFormatos'
})
export class FiltroFormatosPipe implements PipeTransform {

    /**
    * @desc Funcion para transformar un resultado segun unos parametros especificos 
    * (Agrega al array los documentos que coinciden con el criterio de busqueda)
    * @implements
    * @param {Array<any>} arr
    * @param {any} filtro
    * @return {Array}
    */
    transform(arr: Array<any>, filtro: any): any {
        let arrResultado = [];
        let regex = new RegExp(filtro + '.*', 'gi');

        if (filtro) {
            for (let i in arr) {
                let ideFormato = arr[i].ideFormato.toString();
                let nombreCorto = arr[i].nombreCorto ? arr[i].nombreCorto.match(regex) : '';
                if (arr[i].nombre.match(regex) || nombreCorto || arr[i].descripcion.match(regex) || ideFormato.match(regex)) {
                    arrResultado.push(arr[i]);
                }
            }
            return arrResultado;
        } else {
            return arr;
        }
    }

}



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/pipes/filtro-formatos.pipe.ts